import styled, { css } from 'styled-components';

const Header = styled.h2(
  ({ theme }) => css`
    font-size: 1.5rem;
    color: ${theme.text.default};
    font-weight: 700;
    margin: 0;
    flex-shrink: 0;
    border-bottom: 1px solid ${theme.border.default};
    padding: 0 0 0.5rem 0;
  `
);

interface ModalHeaderProps {
  children: React.ReactNode;
}

export function ModalHeader({ children }: ModalHeaderProps) {
  return <Header>{children}</Header>;
}
